import React, { useEffect, useState } from 'react';
import RightSideItem from './RightSideItem';
import './Sidebar.css';
import VideoCallIcon from '@material-ui/icons/VideoCall';
import SearchIcon from '@material-ui/icons/Search';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { Tooltip } from '@material-ui/core';
import { db } from '../Auth/FirebaseConfig';



const RightSide = ({user}) => {
    const [allUser, setAllUser] = useState([]);

    useEffect(() => {
            db.collection('users').onSnapshot(shot => {
                setAllUser(shot.docs.map(doc =>  doc.data()))
            })
        }, [])
 
    return ( 
        <div className='rightSide'>
        <div className="mb-4">
         <hr /> 
            <h3>Contacts
            <Tooltip title='Create Room'><VideoCallIcon className="conIcon1"/></Tooltip>
            <Tooltip title='Search Name or Group'><SearchIcon className="conIcon2"/></Tooltip>   
            <Tooltip title='More Options'><MoreHorizIcon className="conIcon3"/></Tooltip> 
            </h3>            
        </div>
        <div className="contacts">
        {
            allUser.map((user) => 
                <RightSideItem key={user.uid} proName={user.displayName} proImage={user.photoURL} />
            )
        }
            
        </div>
    </div>
       
         ); 
    };

export default RightSide; 